import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { AddMailboxToIntegration } from "../../../../../Integrations"
import {
	generatePath,
	useNavigate,
	useParams,
} from "../../../../../router-utils"

export default function NewIntegratedMailboxPage() {
	const navigate = useNavigate()
	const { integrationId } = useParams(
		"/integrations/:integrationId/email-mailboxes/new"
	)

	return (
		<>
			<Helmet>
				<title>Add Mailbox</title>
			</Helmet>
			<Breadcrumbs
				title="Add Mailbox"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[
						generatePath("/integrations/:integrationId/mail/mailboxes", {
							integrationId,
						}),
						"Integration",
					],
					["", "Add Mailbox"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<AddMailboxToIntegration
								integrationId={integrationId}
								onSuccess={() => {
									navigate("/integrations/:integrationId/mail/mailboxes", {
										params: { integrationId },
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/integrations/:integrationId/mail/mailboxes", {
										params: { integrationId },
										replace: true,
									})
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
